import companies from 'modules/core/store/collections/companies'
import type Company from 'modules/core/store/models/Company'
import type User from 'modules/core/store/models/User'

export const userCompany = (user: User): Company => {
  const companyId = user.attributes.company_id
  const company = companies.get(companyId)

  if (!company) {
    throw Error(`Error getting companies with id = ${companyId}`)
  }

  return company
}
